<script setup lang="ts">
import { useADialog } from '@Atoms';

const props = defineProps<{
  customMessage?: string;
  loading?: boolean;
  rowInfo?: any;
  toBeDeleted?: string;
}>();

const emits = defineEmits(['onDelete']);

const { dialogVisibility } = useADialog();

function onDeleteHandler() {
  emits('onDelete', props.rowInfo);
}
</script>

<template>
  <ADialogWrapper>
    <div class="confirmation-content flex flex-col items-center gap-5 text-center">
      <i class="pi pi-exclamation-triangle mr-3 text-6xl text-orange-400" />

      <span v-if="customMessage"> {{ $t(customMessage) }} </span>

      <span v-else>
        {{
          $t('components.actions.confirmationMessage', {
            item: toBeDeleted ?? $t('common.thisItem'),
          })
        }}
      </span>
    </div>

    <template #footer>
      <Button
        class="af-button"
        severity="secondary"
        :loading
        :label="$t('common.cancel')"
        @click="dialogVisibility = false"
      />

      <Button
        class="af-button"
        icon="pi pi-check"
        severity="danger"
        :loading
        :label="$t('common.yes')"
        @click="onDeleteHandler"
      />
    </template>
  </ADialogWrapper>
</template>
